import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Layout from "../../Layouts/LayoutMain";
import { getTopicDetails } from "../../Store/Topics/Actions";
import ContentManagement from "../../Components/Common/TopicTemplate1";

class ReturnRefundPolicy extends Component {
    componentWillMount() {
        const { getTopicDetails, topicDetails, config: { TOPICS: { RETURN_REFUND_POLICY_TOPIC_ID } }, i18n } = this.props;

        if (!topicDetails[RETURN_REFUND_POLICY_TOPIC_ID] || topicDetails[RETURN_REFUND_POLICY_TOPIC_ID].locale !== i18n.locale) {
            getTopicDetails(RETURN_REFUND_POLICY_TOPIC_ID);
        }
    }

    render() {
        const { isAuthenticated, topicDetails, config: { TOPICS: { RETURN_REFUND_POLICY_TOPIC_ID } } } = this.props;

        return (
            <Layout isAuthenticated={isAuthenticated}>
                {topicDetails[RETURN_REFUND_POLICY_TOPIC_ID] &&
                <ContentManagement
                    title={topicDetails[RETURN_REFUND_POLICY_TOPIC_ID].title}
                    body={topicDetails[RETURN_REFUND_POLICY_TOPIC_ID].body}
                />
                }
            </Layout>
        )
    }
}

ReturnRefundPolicy.propTypes = {
    getTopicDetails: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    i18n: PropTypes.object,
    config: PropTypes.object,
    topicDetails: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        topicDetails: state.topicDetails
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTopicDetails: getTopicDetails
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnRefundPolicy);
